export const careerNewbieFontSize = {
	desktop: {
		heading: {
			min: 50,
			max: 80
		},
		subHeading: {
			min: 16,
			max: 24
		},
	},
	mobile: {
		heading: {
			min: 28,
			max: 60
		},
		subHeading: {
			min: 10,
			max: 18
		},
	},
}

export const careerNewbieClampThreshold = {
	mobile: {
		minWidthPx: 300,
		maxWidthPx: 991,
	},
	desktop: {
		minWidthPx:  991,
		maxWidthPx: 1600
	}
}
